/**
 * liff.adapter — implementation ของ `LiffPort` ด้วย SDK จริง
 *
 * ⚠️ **`@line/liff` ถูก import จาก 2 ไฟล์เท่านั้นทั้ง repo** — ตัวนี้กับ `share.adapter.ts`
 *    ซึ่งอยู่ในกล่องเดียวกัน (`libs/frontend/member/adapters/`) โดยตั้งใจ
 *    · feature lib เห็นแค่ port (`feature-auth/src/types/liff.port.ts` เขียนเหตุผลไว้ครบ)
 *    · `libs/frontend/shared/web/` **ไม่รู้จัก LINE เลย** ⇒ `activities-admin--web`
 *      ไม่ต้องลง dep ตัวนี้
 *    วันเปลี่ยนไปใช้ LINE Login แบบ redirect (Integration-LINE doc §2.2 ทาง A)
 *    แก้ไฟล์นี้ไฟล์เดียว
 */
import liff from '@line/liff';
import type { LiffPort } from '@theelite/frontend-member-feature-auth';

export function createLiffAdapter(liffId: string): LiffPort {
  return {
    async init() {
      await liff.init({ liffId });
    },
    isLoggedIn() {
      return liff.isLoggedIn();
    },
    login() {
      /**
       * ⚠️ ไม่ส่ง `redirectUri` — ปล่อยให้กลับมาที่ URL เดิม (endpoint ของ LIFF app)
       *    ระบุเองแล้วต้องไปเพิ่มใน allowlist ของ LINE console ด้วย ซึ่งเป็นอีกที่
       *    ที่ config หลุดกันได้
       */
      liff.login();
    },
    getIdToken() {
      return liff.getIDToken();
    },
  };
}
